import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import GlobalStyle from './styles/GlobalStyle';

// --- IMPORTS DAS PÁGINAS ---
import Cadastro from './pages/Cadastro';
import Login from './pages/Login';
import CadastroBarbearia from './pages/CadastroBarbearia';
import CadastroServico from './pages/CadastroServico';
import CadastroBarbeiro from './pages/CadastroBarbeiro';

// Páginas do Painel
import Home from './pages/Home';
import Servicos from './pages/Servico';
import Equipe from './pages/Equipe';
import Detalhamento from './pages/Detalhamento';
import MinhaBarbearia from './pages/MinhaBarbearia';
import AgendaHorarios from './pages/AgendaHorarios';
import AgendaComIntervalo from './pages/AgendaComIntervalo';
import ComissaoPage from './pages/ComissaoPage';
import AjudaBarbeiro from './pages/AjudaBarbeiro';
import PlanosAssinatura from './pages/PlanosAssinatura';
import AssinaturaSucesso from './pages/AssinaturaSucesso';
import GerenciarAssinatura from './pages/GerenciarAssinaturas';
import ConfiguracoesUsuario from './pages/ConfiguraçõesUsuario';
import LeadFormAnuncio from './pages/LeadFormAnuncio';
import Faturamento from './pages/Financeiro';
import FilaAdmin from './pages/FilaAdmin';
import FilaTvPage from './pages/FilaTvPage';

// --- IMPORTS DE COMPONENTES E CONTEXTOS ---
import PainelLayout from './components/PainelLayout';
import { BarbeiroProvider } from './context/BarbeiroContext';
import { ToastProvider } from './components/ToastProvider';
import ProtectedRoute from './components/ProtectedRoute';
import RequireAuth from './components/RequireAuth';

function App() {
  return (
    <>
      <ToastProvider hijackWindowAlert defaultDuration={3000}>
        <GlobalStyle />
        <Router>
          <Routes>
            {/* =======================================================
                1. ROTAS PÚBLICAS (Sem Provider, Sem Login)
               ======================================================= */}
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/campanha" element={<LeadFormAnuncio />} />
            <Route path="/tv/:barbeariaId" element={<FilaTvPage />} />

            {/* =======================================================
                2. ÁREA LOGADA (BarbeiroProvider ENVOLVE TUDO)
               ======================================================= */}
            <Route
              element={
                <BarbeiroProvider>
                  <Outlet /> {/* Renderiza as rotas filhas abaixo */}
                </BarbeiroProvider>
              }
            >

              {/* --- GRUPO B: ONBOARDING --- */}
              <Route
                path="/cadastro-barbearia"
                element={
                  <RequireAuth>
                    <CadastroBarbearia />
                  </RequireAuth>
                }
              />
              <Route
                path="/cadastro-servico"
                element={
                  <RequireAuth>
                    <CadastroServico />
                  </RequireAuth>
                }
              />
              <Route
                path="/cadastro-barbeiro"
                element={
                  <RequireAuth>
                    <CadastroBarbeiro />
                  </RequireAuth>
                }
              />

              {/* --- GRUPO C: PAINEL PRINCIPAL (Com Menu Lateral) --- */}
              {/* Todas as rotas internas ficam aqui dentro */}
              <Route element={<PainelLayout />}>
                
                <Route path="/" element={<Home />} />

                {/* Removi a Home daqui para ela não travar o Layout */}
                <Route path="/ajuda" element={<AjudaBarbeiro />} />
                <Route path="/fila" element={<FilaAdmin />} />

                {/* Rotas do Barbeiro */}
                <Route
                  path="/agenda-barbeiro"
                  element={
                    <ProtectedRoute allowedRoles={['barbeiro']}>
                      <AgendaComIntervalo />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/comissao"
                  element={
                    <ProtectedRoute allowedRoles={['barbeiro']}>
                      <ComissaoPage />
                    </ProtectedRoute>
                  }
                />

                {/* Rotas do Proprietário */}
                <Route
                  path="/financeiro"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <Faturamento />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/servicos"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <Servicos />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/equipe"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <Equipe />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/detalhamento"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <Detalhamento />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/minha-barbearia"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <MinhaBarbearia />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/agenda-horarios"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <AgendaHorarios />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/planos"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <PlanosAssinatura />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/assinatura/sucesso"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <AssinaturaSucesso />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/assinatura"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <GerenciarAssinatura />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/configuracoes"
                  element={
                    <ProtectedRoute allowedRoles={['proprietario']}>
                      <ConfiguracoesUsuario />
                    </ProtectedRoute>
                  }
                />
              </Route> {/* Fim do PainelLayout */}

            </Route> {/* Fim do BarbeiroProvider Wrapper */}

          </Routes>
        </Router>
      </ToastProvider>
    </>
  );
}

export default App;